const baseUrl = `${window.location.protocol}//${window.location.hostname}:${window.location.port}`;
// export const url = baseUrl + "/api";
// export const url = `http://192.168.12.220:5001`;
// export const url = `http://localhost:5001`;

export const url = process.env.REACT_APP_API_URL;

export const dateToFormattedString = (date) => {
  const date_str = date.toISOString().slice(0, 16);
  return date_str;
};

export const formattedStringToDate = (date_str) => {
  const newDate = new Date(date_str);
  return newDate;
};

export const addDays = (date, days) => {
  const newDate = new Date(date);
  newDate.setDate(date.getDate() + days);
  return newDate;
};

export const getDayList = (daysBack, daysForward) => {
  const today = new Date();
  const dayList = [];
  for (let i = -daysBack; i <= daysForward; i++) {
    const newDate = new Date(today);
    newDate.setDate(today.getDate() + i);
    newDate.setUTCHours(0, 0, 0, 0); // Set to midnight UTC
    dayList.push(newDate.valueOf());
  }
  return dayList;
};

// utils.js
export function isSameDay(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}


export const sortUnits = (a, b) => {
  if (a.unit_id > b.unit_id) {
    return 1;
  } else {
    return -1;
  }
};

export const round2 = (n) => Math.round(n * 100) / 100;


export function formatPhoneNumber(number) {
  return String(number).replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
}

export const formatCustomerName = (customer, fallback = "Customer") => {
  const name = [customer?.firstName, customer?.lastName]
    .filter(Boolean)
    .join(" ")
    .trim();

  return name || fallback;
};

export const formatCustomerAddress = (customer, fallback = "") => {
  const cityState = [customer?.city, customer?.state].filter(Boolean).join(", ");
  const address = [customer?.address, cityState, customer?.zip]
    .filter(Boolean)
    .join(" ")
    .trim();

  return address || fallback;
};

export const formatCustomerPhone = (phone, fallback = "") => {
  if (!phone) return fallback;

  const value = String(phone);
  const digits = value.replace(/\D/g, "");

  if (digits.length === 10) {
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
  }

  if (digits.length === 11 && digits.startsWith("1")) {
    return `1-${digits.slice(1, 4)}-${digits.slice(4, 7)}-${digits.slice(7)}`;
  }

  return value;
};


export const alignToSunday = (date) => {
  const d = new Date(date);
  d.setUTCHours(0, 0, 0, 0);
  d.setUTCDate(d.getUTCDate() - d.getUTCDay());
  return d.valueOf();
};

export const convertTZ = (date, tzString) => {
  return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));   
}

export const toUtcMidnightTimestamp = (date) => {
  return Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
}

export const dateHasPassed = (date) => {
  const today = new Date();
  const tileIsValid = date >= toUtcMidnightTimestamp(today).valueOf();

  return !tileIsValid;
}

export const getTimeValues = (timeString) => {
  const timeArr = timeString.split(":");

  return {hours: parseInt(timeArr[0]), minutes: parseInt(timeArr[1])}
}

export const getTimeString = (timeObj) => {
  return `${String(timeObj.hours)}:${String(timeObj.minutes)}`;
}

export const dateValToNumeric = (date) => {
  if (!date) return null;
  const inDate = new Date(date);
  console.log(inDate)
  return inDate.toISOString().split('T')[0];
}

export const dateNumericToVal = (date) => {
  if (!date) return;
  const inDate = new Date(date);
  return inDate.valueOf();
}

export const formatDate = (dateValue) => {
  const formattedDate = new Date(
    parseInt(dateValue),
  ).toLocaleDateString("en-US", {
    weekday: "long",
    month: "short",
    day: "numeric",
    timeZone: "UTC",
  });

  return formattedDate;
}

export const getPdfFilename = async (response) => {
  const contentDisposition = response.headers.get('Content-Disposition');
  if (contentDisposition && contentDisposition.includes('filename=')) {
    const filenameMatch = contentDisposition.match(/filename="?([^";]+)"?/);
    if (filenameMatch && filenameMatch[1]) {
      return filenameMatch[1];
    }
  }
  return null;
};

export const formatTime = (hours, minutes) => {
  // Ensure the hours and minutes are in two-digit format (e.g., 9 becomes "09")
  const period = hours >= 12 ? "PM" : "AM";
  const twelveHour = hours % 12 || 12;
  const formattedMinutes = minutes.toString().padStart(2, "0");

  return `${twelveHour}:${formattedMinutes} ${period}`;
};


export const formatTimeRange = (startHours, startMinutes, durationInMinutes) => {
  const start = new Date();
  start.setHours(startHours);
  start.setMinutes(startMinutes);

  const end = new Date(start.getTime() + durationInMinutes * 60000); // add duration in ms

  const options = {
    hour: 'numeric',
    minute: '2-digit',
  };

  const startFormatted = start.toLocaleTimeString('en-US', options);
  const endFormatted = end.toLocaleTimeString('en-US', options);

  return `${startFormatted} – ${endFormatted}`;
};

const getTimeZoneParts = (date, timeZone) => {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone,
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    hourCycle: "h23",
  }).formatToParts(date);

  return Object.fromEntries(
    parts
      .filter((part) => part.type !== "literal")
      .map((part) => [part.type, Number(part.value)])
  );
};

const compareDateParts = (a, b) => {
  if (a.year !== b.year) return a.year - b.year;
  if (a.month !== b.month) return a.month - b.month;
  return a.day - b.day;
};

const addCalendarDays = (dateParts, days) => {
  const date = new Date(Date.UTC(dateParts.year, dateParts.month - 1, dateParts.day + days));

  return {
    year: date.getUTCFullYear(),
    month: date.getUTCMonth() + 1,
    day: date.getUTCDate(),
  };
};

export const hasSlotEndTimePassed = (slot, price, timeZone = "America/New_York") => {
  const slotDate = Number(slot?.date);
  const startHours = Number(price?.startTime?.hours);
  const startMinutes = Number(price?.startTime?.minutes || 0);
  const duration = Number(price?.duration);

  if (
    !Number.isFinite(slotDate) ||
    !Number.isFinite(startHours) ||
    !Number.isFinite(startMinutes) ||
    !Number.isFinite(duration)
  ) {
    return false;
  }

  const slotCalendarDate = new Date(slotDate);
  const endTotalMinutes = startHours * 60 + startMinutes + duration;
  const endDayOffset = Math.floor(endTotalMinutes / (24 * 60));
  const endMinuteOfDay = endTotalMinutes % (24 * 60);
  const slotDateParts = {
    year: slotCalendarDate.getUTCFullYear(),
    month: slotCalendarDate.getUTCMonth() + 1,
    day: slotCalendarDate.getUTCDate(),
  };
  const endDateParts = addCalendarDays(slotDateParts, endDayOffset);
  const nowParts = getTimeZoneParts(new Date(), timeZone);
  const dateComparison = compareDateParts(endDateParts, nowParts);

  if (dateComparison < 0) return true;
  if (dateComparison > 0) return false;

  return endMinuteOfDay <= nowParts.hour * 60 + nowParts.minute;
};

export const minutesToHours = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;

  return { hours: hours, minutes: remainingMinutes };
};

export const isDateValid = (cutoffHour, utcMidnightTimestamp) => {
  const now = new Date();
  const date = new Date(utcMidnightTimestamp);
  
  // Convert current time to Eastern time
  const easternTime = new Intl.DateTimeFormat('en-US', {
    timeZone: 'America/New_York',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    hour12: false,
  }).formatToParts(now);
  
  const easternHour = parseInt(easternTime.find(part => part.type === 'hour').value);
  const easternMonth = parseInt(easternTime.find(part => part.type === 'month').value) - 1; // Month is 0-indexed
  const easternDay = parseInt(easternTime.find(part => part.type === 'day').value);
  const easternYear = parseInt(easternTime.find(part => part.type === 'year').value);

  // Is today the same Eastern date?
  console.log(easternYear, date.getUTCFullYear(), easternMonth, date.getUTCMonth(), easternDay, date.getUTCDate());
  console.log(easternHour, cutoffHour);
  const isSameDay =
    easternYear === date.getUTCFullYear() &&
    easternMonth === date.getUTCMonth() &&
    easternDay === date.getUTCDate();

  // Return true if it's the same day AND before cutoff time
  console.log(isSameDay, easternHour, cutoffHour);
  return isSameDay && easternHour > cutoffHour;
}

export const hasDatePassed = (utcMidnightTimestamp) => {
  const date = new Date(utcMidnightTimestamp);
  const tileDateParts = {
    year: date.getUTCFullYear(),
    month: date.getUTCMonth() + 1,
    day: date.getUTCDate(),
  };
  const todayParts = getTimeZoneParts(new Date(), "America/New_York");

  return compareDateParts(tileDateParts, todayParts) < 0;
}

export const capitalizeFirstLetter = (string) => {
  return string[0].toUpperCase() + string.slice(1);
};

export const put = async (route, data) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    headers: myHeaders,
    method: "PUT",
    body: data,
  };

  try {
    const response = await fetch(`${url + route}`, requestOptions);
    const result = await response.json();
    return {success: true, status: response.status, data: result};
  } catch (error) {
    console.error(error);
    return { success: false, data: error.message };
  }
};

export const post = async (route, data) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions = {
    headers: myHeaders,
    method: "POST",
    body: JSON.stringify({ ...data }),
    redirect: "follow",
  };

  try {
    const response = await fetch(`${url + route}`, requestOptions);
    const result = await response.json();
    return {success: true, status: response.status, data: result};
  } catch (error) {
    console.error(error);
    return { success: false, data: error.message };
  }
};

export const get = async (route) => {
  const requestOptions = {
    method: "GET",
  };

  try {
    const response = await fetch(`${url + route}`, requestOptions);
    const result = await response.json();
    return {success: true, status: response.status, data: result};
  } catch (error) {
    console.error(error);
    return { success: false, data: error.message };
  }
};

export const del = async (route) => {
  const requestOptions = {
    method: "DELETE",
  };

  try {
    const response = await fetch(`${url + route}`, requestOptions);
    const result = await response.json();
    return {success: true, status: response.status, data: result};
  } catch (error) {
    console.error(error);
    return { success: false, data: error.message };
  }
};

export const getPDF = async (route) => {
  const requestOptions = {
    method: "GET",
  };

  try {
    const response = await fetch(`${url + route}`, requestOptions);
    const result = await response;
    return result;
  } catch (error) {
    console.error(error);
    return { success: false, data: error.message };
  }
};

export const getDateHasPassed = (date) => {
  const cutoffTime = new Date().setUTCHours(22, 0, 0, 0); // 6pm EST cutoff for booking
  const tileDate = date.valueOf();
  const todayDate = new Date();

  const tileIsToday =
    date.getUTCDate() === todayDate.getUTCDate() &&
    date.getUTCMonth() === todayDate.getUTCMonth() &&
    date.getUTCFullYear() === todayDate.getUTCFullYear();

  const cutoffHasPassed = tileIsToday && todayDate.valueOf() > cutoffTime; // if its after the cutoff time can't book today
  return tileDate < todayDate.valueOf() - 86400000 || cutoffHasPassed;

}
